// ** React Imports
import { useContext, useState } from 'react'
import { useRouter } from 'next/router'

//** MUI Imports
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

//** Icon Imports
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded'
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded'

// ** Third Party Imports
import { useAutoAnimate } from '@formkit/auto-animate/react'

// ** Axios

// ** Hook Imports
import useFetch from 'src/hooks/useFetch'
import useSWRMutation from 'swr/mutation'
import useSWR from 'swr'
import useSWRImmutable from 'swr/immutable'

// ** Context
import { AuthContext } from 'src/context/AuthContext'

// ** Configs
import endPointRiwayat from 'src/configs/endpoints/riwayatHidupEndPoints'
import endPointRekrutmen from 'src/configs/endpoints/rekrutmenEndPoints'
import { API_URL } from 'src/configs/endpoints/backend-url'

// ** Custom Imports
import myToast from 'src/components/myToast'
import SpinnerSmall from 'src/components/SpinnerSmall'

import { RekrumentDetailResponse } from 'src/types/rekrutmen-detail'

interface DialogProps {
  open: boolean
  setOpen: (open: boolean) => void
}

interface PelamarResponse {
  success: string
  message: string
  data: {
    id: string
    user_id: string
    nik: string
    nomor_telepon: string
    nama_panggilan: string
    tentang_saya: string
    tempat_lahir: string
    tanggal_lahir: string
    jenis_kelamin: string
    agama: string
    status_perkawinan: string
    kewarganegaraan: string
    alamat_ktp: string
    rtrw_ktp: string
    kelurahan_desa_ktp: string
    kecamatan_ktp: string
    kabupaten_kota_ktp: string
    provinsi_ktp: string
    alamat_domisili: string
    rtrw_domisili: string
    kelurahan_desa_domisili: string
    kecamatan_domisili: string
    kabupaten_kota_domisili: string
    provinsi_domisili: string
    npwp: string
    nomor_bpjs_kesehatan: string
    nomor_bpjs_ketenagakerjaan: string
    nomor_rekening: string
    hobi: string
    tinggi_badan: string
    berat_badan: string
    ukuran_baju: string
    ukuran_celana: string
    ukuran_sepatu: string
    alasan_bergabung: string
    visi_bergabung: string
    misi_bergabung: string
    link_video: string
    file_ktp: string
    file_kk: string
    file_kelulusan: string
    file_nilai_kelulusan: string
    file_skck: string
    file_surat_rekomendasi: string
    file_tambahan: string
    created_at: string
    updated_at: string
    user: {
      id: string
      username: string
      email: string
      user_photo: string
      nama_lengkap: string
      role_id: string
      status_user: string
      alasan_blacklist: string
      created_at: string
      updated_at: string
    }
  }
}

interface TitikRekrutmen {
  id: string
  rekrutmen_id: string
  kode: string
  titik: string
  detail: string
  created_at: string
  updated_at: string
}

interface ResponseTitikRekrutmen {
  success: boolean
  message: string
  data: TitikRekrutmen[]
}

const CustomModalJoin = (props: DialogProps) => {
  const { setOpen, open } = props

  const router = useRouter()
  const { id } = router.query

  // ** Hooks
  const { ReqWithPayload } = useFetch()
  const { trigger } = useSWRMutation(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, ReqWithPayload)
  const { FetchWithPayload } = useFetch()

  const { user } = useContext(AuthContext)

  const [titikRekrutmenValue, setTitikRekrutmenValue] = useState('-')
  const [referalRekrutmenValue, setReferalRekrutmenValue] = useState('-')

  const payloadPelamar = {
    url: `${endPointRiwayat.pelamarGetEndpoint}/${user?.id}`,
    method: 'GET'
  }
  const { data: dataPelamar, isLoading: isLoadingPelamar } = useSWR<PelamarResponse>(
    [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadPelamar],
    FetchWithPayload
  )

  const payloadRekrutmen = {
    url: `${endPointRekrutmen.rekrutmenDetailEndpoint}/${id}`,
    method: 'GET'
  }

  const { data: dataRekrutmen, isLoading: isLoadingRekrutmen } = useSWR<RekrumentDetailResponse>(
    id ? [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadRekrutmen] : null,
    FetchWithPayload
  )

  const payloadTitik = {
    url: `${endPointRekrutmen.rekrutmenTitikEndpoint}/${id}`,
    method: 'GET'
  }

  const { data: dataTitik, isLoading: isLoadingTitik } = useSWR<ResponseTitikRekrutmen>(
    id ? [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadTitik] : null,
    FetchWithPayload
  )

  const { data: valueData, isLoading: valueLoading } = useSWRImmutable(
    [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, { url: `${API_URL}/select-value`, method: 'GET' }],
    FetchWithPayload
  )

  const animationParent500 = useAutoAnimate({ duration: 500, easing: 'cubic-bezier(0, 1.4, 1, 1)' })

  const handleClose = () => {
    setOpen(!open)
  }

  // const formData: formData = {
  //   catatan: catatan
  // }

  // const schema = yup.object().shape({
  //   catatan: yup.string().required('Catatan wajib diisi')
  // })

  // // ** Form Hook
  // const {
  //   control,
  //   reset,
  //   handleSubmit,
  //   formState: { errors }
  // } = useForm({
  //   defaultValues: { ...formData },
  //   mode: 'onChange',
  //   resolver: yupResolver(schema)
  // })

  // useEffect(() => {
  //   reset({ catatan })
  // }, [catatan, reset])

  const onSubmit = () => {
    const payload = {
      url: `${endPointRekrutmen.rekrutmenRegistrasiSetEndpoint}/${id}/${user?.id}`,
      method: 'POST',
      body: { rekrutmen_titik_id: titikRekrutmenValue, referal: referalRekrutmenValue }
    }

    const myPromise = new Promise<string>((resolve, reject) => {
      trigger(payload, {
        onSuccess: data => {
          if (data.success) {
            resolve('OK')
            setTimeout(() => {
              setOpen(false)
            }, 1000)
          } else {
            reject(data.errors ? data.errors : data.message ? data.message : 'Unknown Error')
          }
        },
        onError: () => reject('Unknown Error')
      })
    })

    myToast(myPromise, 'Registrasi Sukses!', undefined, 'Registrasi Gagal!')
  }

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        '& .MuiPaper-root': {
          p: 8,
          pt: 12,
          px: 12,
          width: '40%',
          minWidth: 400
        }
      }}
    >
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 4,
          top: 4,
          p: 0,
          color: theme => theme.palette.error.main
        }}
      >
        <HighlightOffRoundedIcon />
      </IconButton>
      <Box sx={{ display: 'flex', flexDirection: 'column' }} ref={animationParent500}>
        <Typography variant='h6' sx={{ mb: 4, fontWeight: 600, color: theme => theme.palette.primary.main }}>
          Registrasi Rekrutmen
        </Typography>
        {!isLoadingPelamar && dataPelamar && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
            <Avatar
              alt=''
              sx={{ mr: 4, width: 56, height: 56, backgroundColor: theme => theme.myColor?.colorToggleLight }}
              src={dataPelamar?.data.user.user_photo}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='caption' sx={{ fontWeight: 600 }}>
                {dataPelamar?.data.user.username}
              </Typography>
              <Typography variant='body1'>{dataPelamar?.data.user.nama_lengkap}</Typography>
            </Box>
          </Box>
        )}

        <Typography variant='body2' sx={{ mb: 1, color: theme => theme.palette.text.primary, fontSize: '0.875rem' }}>
          Anda akan mengikuti Rekrutmen Berikut:
        </Typography>
        {!isLoadingRekrutmen && dataRekrutmen && (
          <Box
            sx={{
              mb: 4,
              py: 4,
              px: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              backgroundColor: theme => theme.myColor?.lightYellow,
              borderRadius: 1
            }}
          >
            <Typography variant='body1' color='primary' sx={{ fontWeight: 600, height: 'fit-content' }}>
              {dataRekrutmen?.data.judul}
            </Typography>
            <Typography variant='caption' color='primary' sx={{ fontWeight: 600, height: 'fit-content' }}>
              {dataRekrutmen?.data.sub_judul}
            </Typography>
            <Chip
              label={dataRekrutmen?.data.rekrutmenklasifikasi.rekrutmen_klasifikasi}
              color='primary'
              variant='outlined'
              sx={{
                mt: 4,
                px: 1,
                fontSize: '0.7rem',
                backgroundColor: theme => theme.palette.primary.main,
                color: theme => theme.myColor?.white,
                borderWidth: 0
              }}
            />
          </Box>
        )}

        <Typography variant='body2' sx={{ mb: 1, color: theme => theme.palette.text.primary, fontSize: '0.875rem' }}>
          Titik Rekrutmen:
        </Typography>

        <TextField
          select
          value={titikRekrutmenValue}
          onChange={e => setTitikRekrutmenValue(e.target.value)}
          id='titikRekrutmen'
          autoComplete='off'
          variant='standard'
          size='small'
          InputProps={{
            sx: {
              px: 2,
              mb: 4,
              backgroundColor: theme => theme.myColor?.colorToggleLight,
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4
            }
          }}
          inputProps={{ sx: { fontSize: '0.875rem', pt: 0.5, pb: 0.5 } }}
          SelectProps={{
            MenuProps: { sx: { maxHeight: 200, '& li': { fontSize: '0.875rem', fontWeight: 600 } } }
          }}
        >
          <MenuItem value='-' disabled>
            <em>Pilih Titik Rekrutmen</em>
          </MenuItem>
          {!isLoadingTitik && dataTitik ? (
            dataTitik.data.map(ele => (
              <MenuItem value={ele.id} key={ele.id}>
                <Box sx={{ display: 'flex' }}>
                  <PlaceRoundedIcon sx={{ color: theme => theme.myColor?.colorToggle }} />
                  <Box sx={{ pl: 2, display: 'flex', flexDirection: 'column' }}>
                    <Typography variant='body1' sx={{ fontWeight: 500, fontSize: '1rem' }}>
                      {`${ele.kode} - ${ele.titik}`}
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            ))
          ) : (
            <Box sx={{ height: 10 }}>
              <SpinnerSmall />
            </Box>
          )}
        </TextField>

        <Typography variant='body2' sx={{ mb: 1, color: theme => theme.palette.text.primary, fontSize: '0.875rem' }}>
          Referal:
        </Typography>

        <TextField
          select
          value={referalRekrutmenValue}
          onChange={e => setReferalRekrutmenValue(e.target.value)}
          id='titikRekrutmen'
          autoComplete='off'
          variant='standard'
          size='small'
          InputProps={{
            sx: {
              px: 2,
              mb: 4,
              backgroundColor: theme => theme.myColor?.colorToggleLight,
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4
            }
          }}
          inputProps={{ sx: { fontSize: '0.875rem', pt: 0.5, pb: 0.5 } }}
          SelectProps={{
            MenuProps: { sx: { maxHeight: 200, '& li': { fontSize: '0.875rem', fontWeight: 600 } } }
          }}
        >
          <MenuItem value='-' disabled>
            <em>Pilih Referal</em>
          </MenuItem>
          {!valueLoading && valueData ? (
            valueData.data.referal.map((ele: any) => (
              <MenuItem value={ele.value} key={ele.value}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant='body1' sx={{ fontWeight: 500, fontSize: '1rem' }}>
                    {ele.value}
                  </Typography>
                </Box>
              </MenuItem>
            ))
          ) : (
            <Box sx={{ height: 10 }}>
              <SpinnerSmall />
            </Box>
          )}
        </TextField>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant='contained'
            color='error'
            onClick={handleClose}
            sx={{ mt: 4, mr: 2, borderRadius: 4, textTransform: 'none', width: 'fit-content' }}
          >
            Batal
          </Button>
          <Button
            disabled={titikRekrutmenValue == '-' || referalRekrutmenValue == '-'}
            variant='contained'
            onClick={() => onSubmit()}
            sx={{ mt: 4, borderRadius: 4, textTransform: 'none', width: 'fit-content' }}
          >
            Registrasi
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default CustomModalJoin
